/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LegendDisplayConfiguration {
    getFixupPrototypeFunction() { return LegendDisplayConfiguration.fixupPrototype; }

    static newInstance(model: Partial<LegendDisplayConfiguration>): LegendDisplayConfiguration {
        let obj = Object.assign(new LegendDisplayConfiguration(), model);
        LegendDisplayConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LegendDisplayConfiguration>): LegendDisplayConfiguration {
        if (!model) return null;
        return LegendDisplayConfiguration.newInstance(<LegendDisplayConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LegendDisplayConfiguration) {
        if (!obj) return;

        models.LegendDisplayConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LegendDisplayConfiguration): boolean {
        Object.setPrototypeOf(obj, LegendDisplayConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    horizontalAlignment: models.HorizontalAlignment;

    verticalAlignment: models.VerticalAlignment;

    /**
     * Legend Text Size
     */
    fontSize: models.LegendDisplayFontSizeSelection;

    /**
     * Legend visibility
     */
    enabled: boolean;

}
